import { render } from "./ExerciseResume.vue?vue&type=template&id=0dc6c741"
import script from "./ExerciseResume.vue?vue&type=script&lang=js"
export * from "./ExerciseResume.vue?vue&type=script&lang=js"

import exportComponent from "/home/farena/workspace/smt/smt_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__